<app-menu></app-menu>
<app-carrossel></app-carrossel>
<app-servicos></app-servicos>
<app-contacto></app-contacto>
<app-rodape></app-rodape>

